import React from "react";
import { QuickLink, TextField } from "components";
import { useExemptionsContext } from "../../ExemptionsContext";
import ButtonV2 from "elements/ButtonV2";

const PortalAccountCredentials = () => {
	const {
		next,
		setSpecialFieldsValue,
		nyGovIdAccountUsername,
		setNyGovIdAccountUsername,
		nyGovIdAccountPassword,
		setNyGovIdAccountPassword,
	} = useExemptionsContext();

	const handleSubmit = async () => {
		next();
	};

	const buttonDisabled = React.useMemo(() => {
		return !nyGovIdAccountUsername || !nyGovIdAccountPassword;
	}, [nyGovIdAccountUsername, nyGovIdAccountPassword]);

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card exemption-survey-card">
				<div className="property-profile-question-card-title-container">
					<p>
						Please provide your login credentials for your Tax.NY.gov ID
						account.
					</p>
				</div>
				<p className="exemption-question-card-subtitle sm">
					Since you already have an account we will have to use it to process
					your exemption on your behalf.
				</p>
				<div className="exemptions-input-flex-container">
					<TextField
						required
						label="Username"
						placeholder="Username"
						containerClassName="exemptions-card-input"
						value={nyGovIdAccountUsername ?? ""}
						onChange={e => {
							setNyGovIdAccountUsername(e.target.value);
						}}
					/>
					<TextField
						required
						label="Password"
						placeholder="Password"
						containerClassName="exemptions-card-input"
						value={nyGovIdAccountPassword ?? ""}
						onChange={e => {
							setNyGovIdAccountPassword(e.target.value);
						}}
					/>
				</div>
			</div>
			<p className="sm exemptions-notification-message-azure">
				If you aren't able to provide your login credentials, we will not be
				able to proceed with filing your exemption for you.
			</p>
			<ButtonV2 size="large" disabled={buttonDisabled} type="submit">
				Continue
			</ButtonV2>
			<ButtonV2
				size="small"
				variant="primary-ghost"
				className="mx-auto mt-2"
				onClick={() => {
					setSpecialFieldsValue({
						does_not_want_to_provide_ny_gov_id_account_credentials: true,
					});
					next();
				}}>
				I do not want to provide this
			</ButtonV2>
		</form>
	);
};

export default PortalAccountCredentials;
